import { mainApi } from "services/main";

interface GenerateChatUrlInput {
  agentName: string;
  protocolType: "WEBSOCKET";
  teamName: string;
  sessionId?: string;
}

interface GenerateChatUrlOutput {
  url: string;
  sessionId: string;
  expiresAt: string;
}

export interface AgentSessionSummary {
  sessionId: string;
  updatedAt: number;
  title?: string;
}

interface ListSessionsInput {
  agentName: string;
  teamName: string;
  limit?: number;
  nextToken?: string | null;
}

interface ListSessionsOutput {
  sessions: AgentSessionSummary[];
  nextToken: string | null;
}

interface CreateAgentAttachmentUploadUrlInput {
  fileName: string;
  sessionId: string;
  teamName: string;
  size: number;
}

interface CreateAgentAttachmentUploadUrlOutput {
  url: string;
  attachmentId: string;
  bucketOwner: string;
  expiresInSeconds?: number;
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    generateChatUrl: builder.mutation<
      GenerateChatUrlOutput,
      GenerateChatUrlInput
    >({
      query: (body) => ({
        url: "agent/chat-url",
        method: "POST",
        body,
      }),
    }),
    listSessions: builder.query<ListSessionsOutput, ListSessionsInput>({
      query: (body) => ({
        url: "agent/sessions",
        method: "POST",
        body,
      }),
    }),
    createAgentAttachmentUploadUrl: builder.mutation<
      CreateAgentAttachmentUploadUrlOutput,
      CreateAgentAttachmentUploadUrlInput
    >({
      query: (body) => ({
        url: "attachments/upload-url",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGenerateChatUrlMutation,
  useLazyListSessionsQuery,
  useCreateAgentAttachmentUploadUrlMutation,
} = extendedApi;
